/**
 * External dependencies
 */
import $ from 'jquery';

export const $win = $(window);
export const $doc = $(document);
export const $body = $('body');
